import 'remixicon/fonts/remixicon.css';
import Routing from './Route/Index';

// Fake backend
import fakeBackend from './helpers/AuthType/fackbackend';
fakeBackend();

function App() {
  return (
    <div className="App">
      <Routing />
    </div>
  );
}

export default App;
